module.exports = __webpack_public_path__ + "assets/15ef43e9dfaba7966f0d4bd81daec06b.mp3";